import { render, staticRenderFns } from "./WeeklyConsumptionComparison.vue?vue&type=template&id=5e70a24e"
import script from "./WeeklyConsumptionComparison.vue?vue&type=script&lang=js"
export * from "./WeeklyConsumptionComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports